import {AuthModel} from './_models'
import {attachAuthInterceptors} from './authInterceptors'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'

const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel
    if (auth) {
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

const isAuthRoutePath = (pathname: string = window.location.pathname): boolean => {
  return pathname.includes('/auth')
}

const isPublicEntryPath = (pathname: string = window.location.pathname): boolean => {
  const normalized = pathname.replace(/\/$/, '') || '/'
  return isAuthRoutePath(pathname) || normalized === '/'
}

const shouldBlockWithSessionSplash = (
  pathname: string = window.location.pathname
): boolean => {
  if (isPublicEntryPath(pathname)) {
    return false
  }

  return Boolean(getAuth()?.token)
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  attachAuthInterceptors(axios, {showSessionExpiredToast: true})
}

export {
  getAuth,
  setAuth,
  removeAuth,
  AUTH_LOCAL_STORAGE_KEY,
  isAuthRoutePath,
  isPublicEntryPath,
  shouldBlockWithSessionSplash,
}
